import { Directive, HostListener, ElementRef, Optional } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({ standalone: false,
  selector: "[docLanguageRestrict]",
})
export class LanguageRestrictDirective {
  private language: "english" | "arabic" | null = null;

  constructor(private el: ElementRef, @Optional() private control: NgControl) {}

  @HostListener("input", ["$event"]) onInput(event: any) {
    const inputValue = this.el.nativeElement.value;

    if (!inputValue) {
      this.language = null;
      this.clearError(); // clear errors on empty
      return;
    }

    const firstChar = inputValue[0];

    if (!this.language) {
      if (this.isArabic(firstChar)) {
        this.language = "arabic";
      } else if (this.isEnglish(firstChar)) {
        this.language = "english";
      } else {
        this.setError(); // invalid start character
        return;
      }
    }

    const filteredValue = Array.from(inputValue)
      .filter((char: string) => {
        if (this.language === "english") {
          return this.isEnglish(char) || this.isAllowed(char);
        } else if (this.language === "arabic") {
          return this.isArabic(char) || this.isAllowed(char);
        }
        return true;
      })
      .join("");

    if (filteredValue !== inputValue) {
      this.el.nativeElement.value = filteredValue;
      this.setError(); // invalid character typed
    } else {
      this.clearError(); // everything is valid
    }
  }

  private isArabic(char: string): boolean {
    const code = char.charCodeAt(0);
    return (
      (code >= 0x0600 && code <= 0x06ff) || (code >= 0x0750 && code <= 0x077f)
    );
  }

  private isEnglish(char: string): boolean {
    return /^[A-Za-z]$/.test(char);
  }

  private isAllowed(char: string): boolean {
    return /[\d\s.,!@#$%^&*()\-_+=\[\]{}:;"'\\\/?><|]/.test(char);
  }

  private setError(): void {
    if (this.control) {
      this.control.control?.setErrors({ languageMismatch: true });
    }
  }

  private clearError(): void {
    if (this.control) {
      const errors = this.control.control?.errors;
      if (errors && errors["languageMismatch"]) {
        delete errors["languageMismatch"];
        if (Object.keys(errors).length === 0) {
          this.control.control?.setErrors(null);
        } else {
          this.control.control?.setErrors(errors);
        }
      }
    }
  }
}
